$(document).ready(function(){
    $(document).on('click touchend', '.sorting-hat-trigger', function(event){
        if (dragging) return;

        event.preventDefault();

        $('body').addClass('loading');

        $ajaxUrl = $(this).attr('href');

        if ($ajaxUrl == "/apply") {
            $('#main-content section:not(#sorting-hat)').show();
        } else {
            $('#main-content section:not(#sorting-hat)').hide();
        }

        $.ajax({
			url: $ajaxUrl,
			type: 'GET',
			success: function(data){
                $('#sorting-hat').html($(data).find('#sorting-hat').html());
			},
			complete: function(data){
                $('body').removeClass('loading');
			}
		});
    });
});